import axios from "axios"
import { apiService } from "./api.service"
import { extractData, handleApiException, handleResponse } from "helpers/apiResponseHelper"
import { ActivateCardsSigningPayload, ContactPersonSigningPayload, SigningAction, ViewPinSigningPayload } from "models/signing";

export type SigningPayload = ActivateCardsSigningPayload | ViewPinSigningPayload | ContactPersonSigningPayload;

async function initMobileIdSigning(customerId: number, nationalIdentityCode: string, phoneNumber: string, payload: SigningPayload, action: SigningAction) {
    return axios.post(apiService.getApiUrl() + '/signing/' + customerId + '/sign/mobile-id/init',
        {
            nationalIdentityCode,
            phoneNumber,
            payload,
            action,
        })
        .then(handleResponse)
        .then(extractData)
        .catch(handleApiException)
}

async function pollMobileIdSigning(customerId: number, signingSessionId: string) {
    return axios.post(apiService.getApiUrl() + '/signing/' + customerId + '/sign/mobile-id/poll',
        {
            signingSessionId
        })
        .then(handleResponse)
        .then(extractData)
        .catch(handleApiException)
}

async function initSmartIdSigning(customerId: number, nationalIdentityCode: string, payload: SigningPayload, action: SigningAction) {
    return axios.post(apiService.getApiUrl() + '/signing/' + customerId + '/sign/smart-id/init',
        {
            nationalIdentityCode,
            payload,
            action,
        })
        .then(handleResponse)
        .then(extractData)
        .catch(handleApiException)
}

async function pollSmartIdSigning(customerId: number, signingSessionId: string) {
    return axios.post(apiService.getApiUrl() + '/signing/' + customerId + '/sign/smart-id/poll',
        {
            signingSessionId
        })
        .then(handleResponse)
        .then(extractData)
        .catch(handleApiException)
}

async function initIdCardSigning(customerId: number, certHash: string, payload: SigningPayload, action: SigningAction) {
    return axios.post(apiService.getApiUrl() + '/signing/' + customerId + '/sign/id-card/init',
        {
            payload,
            action,
            certHash
        })
        .then(handleResponse)
        .then(extractData)
        .catch(handleApiException)
}
async function finalizeIdCardSigning(customerId: number, signingSessionId: string, signatureHash: string) {
    return axios.post(apiService.getApiUrl() + '/signing/' + customerId + '/sign/id-card/finalize',
        {
            signingSessionId,
            signatureHash
        })
        .then(handleResponse)
        .then(extractData)
        .catch(handleApiException)
}

const SigningService = {
    initMobileIdSigning, 
    pollMobileIdSigning,
    initSmartIdSigning,
    pollSmartIdSigning,
    initIdCardSigning,
    finalizeIdCardSigning
};

export default SigningService;